export const GET_DASHBOARD_SEND_TASKS = 'GET_DASHBOARD_SEND_TASKS';
export const GET_DASHBOARD_SEND_TASKS_SUCCESS = 'GET_DASHBOARD_SEND_TASKS_SUCCESS';
export const GET_DASHBOARD_SEND_TASKS_ERROR = 'GET_DASHBOARD_SEND_TASKS_ERROR';
